import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';
import getInvoicesRepository from './getInvoices.repository';

type InitialState = {
  loading: boolean;
  data?: GetInvoicesDto[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getInvoices = createAsyncThunk(
  'getInvoices',
  async ({ ids, journalType }: { ids?: any; journalType?: string[] }) => {
    return await getInvoicesRepository(ids,journalType).catch((error) => {
      throw error;
    });
  }
);

const getInvoicesSlice = createSlice({
  name: 'getInvoices',
  initialState,
  reducers: {
    getInvoicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getInvoices.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getInvoices.fulfilled,
      (state, action: PayloadAction<GetInvoicesDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      },
    );
    builder.addCase(getInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getInvoicesSlice.reducer;
export const { getInvoicesReset } = getInvoicesSlice.actions;
